import { createSelector } from '@ngrx/store';

import { TargetRatesRootStore, TargetRatesState } from 'TargetRatesApp/interfaces/state.interface';

export const getTargetRatesState = ({ appStateSliceKey, ...state }: TargetRatesRootStore): TargetRatesState =>
    state[appStateSliceKey];

export const getShowRecessions = createSelector(getTargetRatesState, (state) => state?.showRecessions ?? false);
